import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { Timer } from "@phosphor-icons/react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { ConvertGuestDialog } from "@/components/ConvertGuestDialog";

export function GuestBanner() {
  const { t, user } = useApp();
  const [convertOpen, setConvertOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [saved, setSaved] = useState(false);
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((n) => n + 1), 60000);
    return () => clearInterval(id);
  }, []);

  if (!user || !user.is_guest) return null;

  let daysLeft = null;
  let hoursLeft = null;
  if (user.guest_expires_at) {
    const ms = new Date(user.guest_expires_at).getTime() - Date.now();
    daysLeft = Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
    hoursLeft = Math.max(0, Math.ceil(ms / (1000 * 60 * 60)));
  }
  const countdown = daysLeft == null ? "" : (daysLeft > 1
    ? `${daysLeft} ${t("daysWord")}`
    : `${hoursLeft} ${hoursLeft === 1 ? t("hourWord") : t("hoursWord")}`);

  const saveEmail = async () => {
    try {
      await api.post("/guest/email", { email });
      setSaved(true);
      toast.success(t("guestEmailSaved"));
    } catch (e) {
      toast.error(e.response?.data?.detail || "Fehler");
    }
  };

  return (
    <div data-testid="guest-banner" className="rounded-2xl border-2 border-gray-900 px-4 py-3 mb-4 shadow-[3px_3px_0_0_rgba(31,41,55,1)]" style={{ background: "#FEF9C3" }}>
      <div className="flex items-start gap-2">
        <Timer size={24} weight="duotone" className="shrink-0 mt-0.5 text-gray-800" />
        <div className="flex-1 min-w-0">
          <p className="font-heading font-semibold text-gray-900 text-sm" data-testid="guest-banner-title">
            {t("guestModeTitle")}{daysLeft != null ? ` · ${t("guestDaysPrefix")} ${countdown}` : ""}
          </p>
          <p className="font-body text-xs text-gray-700 mt-0.5">{t("guestModeDesc")}</p>
          <button data-testid="guest-register-now" onClick={() => setConvertOpen(true)}
            className="sb-btn mt-2 px-4 py-2 text-white font-medium text-sm" style={{ background: "var(--app-primary)" }}>
            {t("guestRegisterNow")}
          </button>
          {saved ? (
            <p className="font-body text-xs text-green-700 mt-2" data-testid="guest-email-saved">✓ {t("guestEmailSaved")}</p>
          ) : (
            <div className="flex gap-2 mt-2">
              <input data-testid="guest-email-input" type="email" className="sb-input text-sm py-2" placeholder={t("guestEmailLabel")} value={email} onChange={(e) => setEmail(e.target.value)} />
              <button data-testid="guest-email-save" onClick={saveEmail} disabled={!email.trim()}
                className="sb-btn px-3 py-2 bg-white font-medium text-sm disabled:opacity-50 shrink-0">{t("guestEmailSave")}</button>
            </div>
          )}
        </div>
      </div>
      <ConvertGuestDialog open={convertOpen} onOpenChange={setConvertOpen} />
    </div>
  );
}
